<template>
  <div> 平级详情页 </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({});
</script>
